"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rateLimitify = void 0;
const task_exec_1 = require("../common/tesk-exec/task-exec");
const simple_rate_limit_counter_1 = require("./simple-rate-limit-counter");
function handleAsyncRateLimit(target, resolvedConfig, key, taskExec, originalMethod, args) {
    return __awaiter(this, void 0, void 0, function* () {
        const rateLimitCounter = resolvedConfig.rateLimitAsyncCounter;
        const currentCount = yield rateLimitCounter.getCount(key);
        if (currentCount >= resolvedConfig.allowedCalls) {
            resolvedConfig.exceedHandler();
        }
        yield rateLimitCounter.inc(key);
        taskExec.exec(() => {
            rateLimitCounter.dec(key);
        }, resolvedConfig.timeSpanMs);
        return originalMethod.apply(target, args);
    });
}
function handleRateLimit(target, resolvedConfig, key, taskExec, originalMethod, args) {
    const { rateLimitCounter } = resolvedConfig;
    const currentCount = rateLimitCounter.getCount(key);
    if (currentCount >= resolvedConfig.allowedCalls) {
        resolvedConfig.exceedHandler();
    }
    rateLimitCounter.inc(key);
    taskExec.exec(() => {
        rateLimitCounter.dec(key);
    }, resolvedConfig.timeSpanMs);
    return originalMethod.apply(target, args);
}
function rateLimitify(originalMethod, config) {
    if (config.rateLimitAsyncCounter && config.rateLimitCounter) {
        throw new Error('You cant provide both rateLimitAsyncCounter and rateLimitCounter.');
    }
    const taskExec = new task_exec_1.TaskExec();
    const resolvedConfig = Object.assign({ rateLimitCounter: new simple_rate_limit_counter_1.SimpleRateLimitCounter(), exceedHandler: () => {
            throw new Error('You have acceded the amount of allowed calls');
        }, keyResolver: () => '__rateLimit__' }, config);
    return function (...args) {
        const keyResolver = typeof resolvedConfig.keyResolver === 'string'
            ? this[resolvedConfig.keyResolver] : resolvedConfig.keyResolver.bind(this);
        const key = keyResolver(...args);
        if (resolvedConfig.rateLimitAsyncCounter) {
            return handleAsyncRateLimit(this, resolvedConfig, key, taskExec, originalMethod, args);
        }
        return handleRateLimit(this, resolvedConfig, key, taskExec, originalMethod, args);
    };
}
exports.rateLimitify = rateLimitify;
